import { useBranding } from "@/app/branding/branding.context";

/**
 * Header del sidebar (logo + nombre del sistema). Compartido entre
 * `SidebarNavegacion` y `SidebarProcesoTesis` (DRY).
 *
 * ADR 039 (Fase 0 del SaaS): el nombre y el logo salen del branding por
 * institución (`useBranding`), no de literales. El logo cae a un placeholder de
 * color de marca cuando `logoUrl` es null, evitando un `<img>` roto.
 */
export function SidebarHeader() {
  const branding = useBranding();

  return (
    <div className="flex h-16 items-center gap-2 border-b border-border px-6">
      {branding.logoUrl ? (
        <img
          src={branding.logoUrl}
          alt={`Logo de ${branding.nombreCorto}`}
          className="h-8 w-8 rounded-md object-contain"
        />
      ) : (
        <div className="h-8 w-8 rounded-md bg-brand-500" aria-hidden="true" />
      )}
      <div>
        {/* Tinta de marca de la barra: brand-700 en estilo claro, blanco en
            "oscuro de marca" — legible en ambos (ADR 047). */}
        <h1 className="text-sm font-bold text-sidebar-active-foreground">
          {branding.nombreSistemaCorto}
        </h1>
        <p className="text-xs text-muted-foreground">{branding.nombreCorto}</p>
      </div>
    </div>
  );
}
